import React from "react"

function IconVoicemail({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (<svg  fill={color} fuze-icon="voicemail"viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{height: height || fontSize}} originalclass="fz-icon fz-icon-voicemail"{...props}><path d="m6.493 15.588-.215-.006a4.186 4.186 0 1 1 3.256-1.302h4.958a4.187 4.187 0 1 1 3.256 1.303l-.215.005H6.493zm11.04-7.063a2.878 2.878 0 1 0 0 5.756 2.878 2.878 0 0 0 0-5.756zm-11.04 0a2.877 2.877 0 1 0 0 5.755 2.877 2.877 0 0 0 0-5.755z" fill={color} fillRule="evenodd" style={{height: height || fontSize}} originalclass="__primary"/></svg>)
}

export default IconVoicemail
